/* tslint:disable */
/* eslint-disable */
/**
 * TOM STORAGE SERVICE API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AllocationRulePropertiesDto } from '../model';
// @ts-ignore
import type { AllocationRuleSummaryDto } from '../model';
// @ts-ignore
import type { BaseEventWrapper } from '../model';
// @ts-ignore
import type { CarrierVisitAllocationRuleDto } from '../model';
// @ts-ignore
import type { CarrierVisitContainerDataDto } from '../model';
// @ts-ignore
import type { CarrierVisitDirection } from '../model';
// @ts-ignore
import type { CarrierVisitDto } from '../model';
// @ts-ignore
import type { CarrierVisitStatus } from '../model';
// @ts-ignore
import type { CarrierVisitSummaryDto } from '../model';
// @ts-ignore
import type { CreateCarrierVisitAllocationAndRulesDto } from '../model';
/**
 * CarrierVisitsApi - axios parameter creator
 */
export const CarrierVisitsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Array<AllocationRulePropertiesDto>} [allocationRulePropertiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsAllocationSummary: async (allocationRulePropertiesDto?: Array<AllocationRulePropertiesDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/AllocationSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(allocationRulePropertiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateCarrierVisitAllocationAndRulesDto} [createCarrierVisitAllocationAndRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsCreateCarrierVisitAllocationAndRules: async (createCarrierVisitAllocationAndRulesDto?: CreateCarrierVisitAllocationAndRulesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/CreateCarrierVisitAllocationAndRules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCarrierVisitAllocationAndRulesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGet: async (id?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/Get`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<CarrierVisitStatus>} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetAll: async (query?: Array<CarrierVisitStatus>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/GetAll`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (query) {
                localVarQueryParameter['query'] = query;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} carrierVisitId 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetAllocationRules: async (carrierVisitId: number, direction?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'carrierVisitId' is not null or undefined
            assertParamExists('carrierVisitsGetAllocationRules', 'carrierVisitId', carrierVisitId)
            const localVarPath = `/storage/api/CarrierVisits/GetAllocationRules/{carrierVisitId}`
                .replace(`{${"carrierVisitId"}}`, encodeURIComponent(String(carrierVisitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetCarrierVisitContainerData: async (date?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/GetCarrierVisitContainerData`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString().substring(0,10) :
                    date;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {CarrierVisitDirection} [visitDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetCarrierVisitSummary: async (id?: number, visitDirection?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/GetCarrierVisitSummary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (visitDirection !== undefined) {
                localVarQueryParameter['visitDirection'] = visitDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [id] 
         * @param {CarrierVisitDirection} [visitDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetCarrierVisitSummaryV2: async (id?: number, visitDirection?: CarrierVisitDirection, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/GetCarrierVisitSummaryV2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (visitDirection !== undefined) {
                localVarQueryParameter['visitDirection'] = visitDirection;
            }

            localVarHeaderParameter['Accept'] = 'text/plain,application/json,text/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {BaseEventWrapper} [baseEventWrapper] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsUpsert: async (baseEventWrapper?: BaseEventWrapper, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/storage/api/CarrierVisits/Upsert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "Bearer", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(baseEventWrapper, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CarrierVisitsApi - functional programming interface
 */
export const CarrierVisitsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CarrierVisitsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {Array<AllocationRulePropertiesDto>} [allocationRulePropertiesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsAllocationSummary(allocationRulePropertiesDto?: Array<AllocationRulePropertiesDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AllocationRuleSummaryDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsAllocationSummary(allocationRulePropertiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsAllocationSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CreateCarrierVisitAllocationAndRulesDto} [createCarrierVisitAllocationAndRulesDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsCreateCarrierVisitAllocationAndRules(createCarrierVisitAllocationAndRulesDto?: CreateCarrierVisitAllocationAndRulesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsCreateCarrierVisitAllocationAndRules(createCarrierVisitAllocationAndRulesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsCreateCarrierVisitAllocationAndRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsGet(id?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierVisitDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<CarrierVisitStatus>} [query] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsGetAll(query?: Array<CarrierVisitStatus>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsGetAll(query, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsGetAll']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} carrierVisitId 
         * @param {CarrierVisitDirection} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsGetAllocationRules(carrierVisitId: number, direction?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitAllocationRuleDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsGetAllocationRules(carrierVisitId, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsGetAllocationRules']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsGetCarrierVisitContainerData(date?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CarrierVisitContainerDataDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsGetCarrierVisitContainerData(date, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsGetCarrierVisitContainerData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {CarrierVisitDirection} [visitDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsGetCarrierVisitSummary(id?: number, visitDirection?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierVisitSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsGetCarrierVisitSummary(id, visitDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsGetCarrierVisitSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [id] 
         * @param {CarrierVisitDirection} [visitDirection] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsGetCarrierVisitSummaryV2(id?: number, visitDirection?: CarrierVisitDirection, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CarrierVisitSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsGetCarrierVisitSummaryV2(id, visitDirection, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsGetCarrierVisitSummaryV2']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {BaseEventWrapper} [baseEventWrapper] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async carrierVisitsUpsert(baseEventWrapper?: BaseEventWrapper, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.carrierVisitsUpsert(baseEventWrapper, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CarrierVisitsApi.carrierVisitsUpsert']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CarrierVisitsApi - factory interface
 */
export const CarrierVisitsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CarrierVisitsApiFp(configuration)
    return {
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsAllocationSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsAllocationSummary(requestParameters: CarrierVisitsApiCarrierVisitsAllocationSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<AllocationRuleSummaryDto>> {
            return localVarFp.carrierVisitsAllocationSummary(requestParameters.allocationRulePropertiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsCreateCarrierVisitAllocationAndRules(requestParameters: CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.carrierVisitsCreateCarrierVisitAllocationAndRules(requestParameters.createCarrierVisitAllocationAndRulesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGet(requestParameters: CarrierVisitsApiCarrierVisitsGetRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CarrierVisitDto> {
            return localVarFp.carrierVisitsGet(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsGetAllRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetAll(requestParameters: CarrierVisitsApiCarrierVisitsGetAllRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarrierVisitDto>> {
            return localVarFp.carrierVisitsGetAll(requestParameters.query, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsGetAllocationRulesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetAllocationRules(requestParameters: CarrierVisitsApiCarrierVisitsGetAllocationRulesRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarrierVisitAllocationRuleDto>> {
            return localVarFp.carrierVisitsGetAllocationRules(requestParameters.carrierVisitId, requestParameters.direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsGetCarrierVisitContainerDataRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetCarrierVisitContainerData(requestParameters: CarrierVisitsApiCarrierVisitsGetCarrierVisitContainerDataRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<Array<CarrierVisitContainerDataDto>> {
            return localVarFp.carrierVisitsGetCarrierVisitContainerData(requestParameters.date, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetCarrierVisitSummary(requestParameters: CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<CarrierVisitSummaryDto> {
            return localVarFp.carrierVisitsGetCarrierVisitSummary(requestParameters.id, requestParameters.visitDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsGetCarrierVisitSummaryV2(requestParameters: CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryV2Request = {}, options?: RawAxiosRequestConfig): AxiosPromise<CarrierVisitSummaryDto> {
            return localVarFp.carrierVisitsGetCarrierVisitSummaryV2(requestParameters.id, requestParameters.visitDirection, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CarrierVisitsApiCarrierVisitsUpsertRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        carrierVisitsUpsert(requestParameters: CarrierVisitsApiCarrierVisitsUpsertRequest = {}, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.carrierVisitsUpsert(requestParameters.baseEventWrapper, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for carrierVisitsAllocationSummary operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsAllocationSummaryRequest {
    readonly allocationRulePropertiesDto?: Array<AllocationRulePropertiesDto>
}

/**
 * Request parameters for carrierVisitsCreateCarrierVisitAllocationAndRules operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest {
    readonly createCarrierVisitAllocationAndRulesDto?: CreateCarrierVisitAllocationAndRulesDto
}

/**
 * Request parameters for carrierVisitsGet operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsGetRequest {
    readonly id?: number
}

/**
 * Request parameters for carrierVisitsGetAll operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsGetAllRequest {
    readonly query?: Array<CarrierVisitStatus>
}

/**
 * Request parameters for carrierVisitsGetAllocationRules operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsGetAllocationRulesRequest {
    readonly carrierVisitId: number

    readonly direction?: CarrierVisitDirection
}

/**
 * Request parameters for carrierVisitsGetCarrierVisitContainerData operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsGetCarrierVisitContainerDataRequest {
    readonly date?: string
}

/**
 * Request parameters for carrierVisitsGetCarrierVisitSummary operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryRequest {
    readonly id?: number

    readonly visitDirection?: CarrierVisitDirection
}

/**
 * Request parameters for carrierVisitsGetCarrierVisitSummaryV2 operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryV2Request {
    readonly id?: number

    readonly visitDirection?: CarrierVisitDirection
}

/**
 * Request parameters for carrierVisitsUpsert operation in CarrierVisitsApi.
 */
export interface CarrierVisitsApiCarrierVisitsUpsertRequest {
    readonly baseEventWrapper?: BaseEventWrapper
}

/**
 * CarrierVisitsApi - object-oriented interface
 */
export class CarrierVisitsApi extends BaseAPI {
    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsAllocationSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsAllocationSummary(requestParameters: CarrierVisitsApiCarrierVisitsAllocationSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsAllocationSummary(requestParameters.allocationRulePropertiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsCreateCarrierVisitAllocationAndRules(requestParameters: CarrierVisitsApiCarrierVisitsCreateCarrierVisitAllocationAndRulesRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsCreateCarrierVisitAllocationAndRules(requestParameters.createCarrierVisitAllocationAndRulesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsGet(requestParameters: CarrierVisitsApiCarrierVisitsGetRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsGet(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsGetAllRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsGetAll(requestParameters: CarrierVisitsApiCarrierVisitsGetAllRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsGetAll(requestParameters.query, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsGetAllocationRulesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsGetAllocationRules(requestParameters: CarrierVisitsApiCarrierVisitsGetAllocationRulesRequest, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsGetAllocationRules(requestParameters.carrierVisitId, requestParameters.direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsGetCarrierVisitContainerDataRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsGetCarrierVisitContainerData(requestParameters: CarrierVisitsApiCarrierVisitsGetCarrierVisitContainerDataRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsGetCarrierVisitContainerData(requestParameters.date, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsGetCarrierVisitSummary(requestParameters: CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsGetCarrierVisitSummary(requestParameters.id, requestParameters.visitDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsGetCarrierVisitSummaryV2(requestParameters: CarrierVisitsApiCarrierVisitsGetCarrierVisitSummaryV2Request = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsGetCarrierVisitSummaryV2(requestParameters.id, requestParameters.visitDirection, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CarrierVisitsApiCarrierVisitsUpsertRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public carrierVisitsUpsert(requestParameters: CarrierVisitsApiCarrierVisitsUpsertRequest = {}, options?: RawAxiosRequestConfig) {
        return CarrierVisitsApiFp(this.configuration).carrierVisitsUpsert(requestParameters.baseEventWrapper, options).then((request) => request(this.axios, this.basePath));
    }
}

